const dotClass = 'inline-block w-2 h-2 bg-brand-800 rounded-full scale-0';

function TypingLoader() {
    return (
        <div className='flex items-center justify-center h-6 mx-20 space-x-1 typing-loader'>
            <span className={dotClass} />
            <span className={dotClass} />
            <span className={dotClass} />
        </div>
    );
}

export default TypingLoader;
